var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "checkbox-component", on: { click: _vm.onClick } },
    [
      _c(
        "div",
        {
          staticClass: "checkbox-component-button",
          class: { "checkbox-component-button-checked": _vm.internalChecked },
        },
        [
          _c("input", {
            ref: "input",
            staticClass: "checkbox-component-button-input",
            attrs: { name: _vm.name, type: "checkbox" },
            domProps: { checked: _vm.internalChecked },
            on: { change: _vm.onChange },
          }),
          _c("IconComponent", [_vm._v("check")]),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "checkbox-component-label" },
        [_vm._t("default")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }